<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{ 'Home' | translate }}</a></li>
                <li class="breadcrumb-item active screen-reader">{{ "ContentSearch" | translate }}</li>
            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->
 
    <div class="inner-page main-content-search">
        <div class="inner-page-details">
            <div class="row">
                <div class="col-lg-12">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details mb-5">
                                    <div class="title">
                                        <h2 class="screen-reader">{{ "ContentSearch" | translate }}</h2>
                                    </div>
                                    <div class="description">
                                        <div class="press-release">
                                            <div class="row">
                                                <div class="col-lg-12">

                                                    <!-- content search section area -->

                                                    <div class="relieving-order">

                        <!-- search section -->

                        <div class="searchpanel notific-frm" >
                            <div class="row">
                                <form [formGroup]="searchForm"
                                    (ngSubmit)="searchGlobal()">
                                    <div
                                        class="col-xxl-4 col-xl-5 col-lg-4 col-md-6 col-sm-6 col-12">
                                        <div
                                            class="d-flex gap-3 align-items-center mb-2 mt-2">

                                            <input type="text" name="keywords"
                                                id="keywords" formControlName="keywords"
                                                autocomplete="off" class="form-control screen-reader"
                                                placeholder="{{'SearchFCI' | translate}}">
                                            <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'"
                                                class="btn btn-success screen-reader" [innerHTML]="btncontent"> </button>
                                            <button type="button"
                                                class="btn btn-outline-secondary py-0-2 screen-reader" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'"
                                                (click)="RefreshPage()"
                                                *ngIf="RefreshBtn">
                                                <i class="bi bi-arrow-repeat fs-5" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <!-- search section -->


                                        <div class="row mt-3" *ngIf="hastenderlist">
                                            <div class="col-xl-12 col-lg-12 col-md-12 search-result">
                                                <h5 class="search-result-text mb-1 screen-reader">{{ "SearchresultsinTender" | translate }}</h5>

                                                <div *ngFor="let item of tenderlist;">
                                                    <div class="content-srhsec mt-3">
                                                        <a class="srh-tx screen-reader" href="javascript:void(0);"
                                                            (click)="viewDetails(item.intId,'tender-details')"
                                                            [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'">
                                                            {{ htmlTag(language=='English'?item.TITLE:item.HINDI_TITLE) }}
                                                        </a>
                                                        <a class="url-tx font-adjust d-flex align-items-center screen-reader" href="javascript:void(0);"
                                                            routerLink="/tender" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"><i
                                                                class="fa fa-hand-o-right me-2 text-green"
                                                                aria-hidden="true"></i><span>{{ site_url
                                                            }}tender</span></a>
                                                        <p class="font-adjust screen-reader" [innerHTML]="encDec.decodeHtml(contentLengthSet(language=='English'?item.DESCRIPTION:item.HINDI_DESCRIPTION,250))">
                                                        </p>
                                                    </div>
                                                    <hr class="mb-0">
                                                </div>

                                            </div>
                                        </div>


                                        <div class="row mt-3" *ngIf="hasrecruitmentlist">
                                            <div class="col-xl-12 col-lg-12 col-md-12">
                                                <h5 class="search-result-text mb-1 screen-reader">{{ "SearchresultsinRecruitment" | translate }}</h5>

                                                <ng-container *ngFor="let item of recruitmentlist;">
                                                    <div class="content-srhsec mt-3">
                                                        <a class="srh-tx screen-reader" href="javascript:void(0);"
                                                            routerLink="/recruitment"
                                                            [attr.title]="language=='English'?'Recruitment':'भर्ती'">
                                                            {{ htmlTag(language=='English'?item.TITLE:item.HINDI_TITLE) }}
                                                        </a>
                                                        <a class="url-tx font-adjust d-flex align-items-center screen-reader" href="javascript:void(0);"
                                                            routerLink="/recruitment"
                                                            [attr.title]="language=='English'?'Recruitment':'भर्ती'"><i
                                                                class="fa fa-hand-o-right me-2 text-green"
                                                                aria-hidden="true"></i><span>{{ site_url }}recruitment</span></a>
                                                            <p class="screen-reader font-adjust" [innerHTML]="encDec.decodeHtml(contentLengthSet(language=='English'?item.DESCRIPTION:item.HINDI_DESCRIPTION,250))">
                                                            </p>
                                                    </div>
                                                    <hr class="mb-0">
                                                </ng-container>

                                            </div>
                                        </div>

                                        <div class="row mt-3" *ngIf="hasawardlist">
                                            <div class="col-xl-12 col-lg-12 col-md-12">
                                                <h5 class="search-result-text mb-1 screen-reader">{{ "SearchresultsinAward" | translate }}</h5>

                                                <ng-container *ngFor="let item of awardlist;">
                                                    <div class="content-srhsec mt-3">
                                                        <a class="srh-tx screen-reader" href="javascript:void(0);"
                                                            (click)="viewDetails(item.intId,'awarddetails')"
                                                            [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'">
                                                            {{ htmlTag(language=='English'?item.TITLE:item.HINDI_TITLE) }}
                                                        </a>
                                                        <a class="url-tx font-adjust d-flex align-items-center screen-reader" href="javascript:void(0);"
                                                            routerLink="/award" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"><i
                                                                class="fa fa-hand-o-right me-2 text-green"
                                                                aria-hidden="true"></i><span>{{ site_url
                                                            }}award</span></a>
                                                            <p class="screen-reader font-adjust" [innerHTML]="encDec.decodeHtml(contentLengthSet(language=='English'?item.DESCRIPTION:item.HINDI_DESCRIPTION,250))">
                                                            </p>
                                                    </div>
                                                    <hr class="mb-0">
                                                </ng-container>

                                            </div>
                                        </div>


                                        <div class="row mt-3" *ngIf="hascircularlist">
                                            <div class="col-xl-12 col-lg-12 col-md-12">
                                                <h5 class="search-result-text mb-1 screen-reader">{{ "SearchresultsinCircular" | translate }}</h5>

                                                <ng-container *ngFor="let item of circularlist;">
                                                    <div class="content-srhsec mt-3">
                                                        <a class="srh-tx screen-reader" href="javascript:void(0);"
                                                            (click)="viewDetails(item.intId,'circulardetails')"
                                                            [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'">
                                                            {{ htmlTag(language=='English'?item.TITLE:item.HINDI_TITLE) }}
                                                        </a>
                                                        <a class="url-tx font-adjust d-flex align-items-center screen-reader" href="javascript:void(0);"
                                                            routerLink="/circular" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"><i
                                                                class="fa fa-hand-o-right me-2 text-green"
                                                                aria-hidden="true"></i><span>{{ site_url
                                                            }}circular</span></a>
                                                            <p class="screen-reader font-adjust" [innerHTML]="encDec.decodeHtml(contentLengthSet(language=='English'?item.DESCRIPTION:item.HINDI_DESCRIPTION,250))">
                                                            </p>
                                                    </div>
                                                    <hr class="mb-0">
                                                </ng-container>

                                            </div>
                                        </div>

                                        <div class="row mt-3" *ngIf="hasnewslist">
                                            <div class="col-xl-12 col-lg-12 col-md-12">
                                                <h5 class="search-result-text mb-1 screen-reader">{{ "SearchresultsinNews" | translate }}</h5>

                                                <ng-container *ngFor="let item of newslist;">
                                                    <div class="content-srhsec mt-3">
                                                        <a class="srh-tx screen-reader" href="javascript:void(0);"
                                                            (click)="viewDetails(item.intId,'news')"
                                                            [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'">
                                                            {{ htmlTag(language=='English'?item.TITLE:item.HINDI_TITLE) }}
                                                        </a>
                                                        <a class="url-tx font-adjust d-flex align-items-center screen-reader" href="javascript:void(0);"
                                                            routerLink="/newslist" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"><i
                                                                class="fa fa-hand-o-right me-2 text-green"
                                                                aria-hidden="true"></i><span>{{ site_url }}newslist</span></a>
                                                            <p class="screen-reader font-adjust" [innerHTML]="encDec.decodeHtml(contentLengthSet(language=='English'?item.DESCRIPTION:item.HINDI_DESCRIPTION,250))">
                                                            </p>
                                                    </div>
                                                    <hr class="mb-0">
                                                </ng-container>

                                            </div>
                                        </div>

                                        <div class="row mt-3" *ngIf="haspressReleaselist">
                                            <div class="col-xl-12 col-lg-12 col-md-12">
                                                <h5 class="search-result-text mb-1 screen-reader">{{ "SearchresultsinPressRelease" | translate }}</h5>

                                                <ng-container *ngFor="let item of pressReleaselist;">
                                                    <div class="content-srhsec mt-3">
                                                        <a class="srh-tx screen-reader" href="javascript:void(0);"
                                                            (click)="viewDetails(item.intId,'pressreleasedetails')"
                                                            [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'">
                                                            {{ htmlTag(language=='English'?item.TITLE:item.HINDI_TITLE) }}
                                                        </a>
                                                        <a class="url-tx font-adjust d-flex align-items-center screen-reader" href="javascript:void(0);"
                                                            routerLink="/pressrelease"
                                                            [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"><i
                                                                class="fa fa-hand-o-right me-2 text-green"
                                                                aria-hidden="true"></i><span>{{ site_url }}pressrelease</span></a>
                                                            <p class="screen-reader font-adjust" [innerHTML]="encDec.decodeHtml(contentLengthSet(language=='English'?item.DESCRIPTION:item.HINDI_DESCRIPTION,250))">
                                                            </p>
                                                    </div>
                                                    <hr class="mb-0">
                                                </ng-container>

                                            </div>
                                        </div>

                                        <div class="row mt-3" *ngIf="hasmenulist">
                                            <div class="col-xl-12 col-lg-12 col-md-12">
                                                <h5 class="search-result-text mb-1 mb-3 screen-reader">{{ "SearchresultsinMenu" | translate }}</h5>

<div *ngFor="let item of menulist;">
<div [ngSwitch]="item.DESCRIPTION">
    <div *ngSwitchCase="1"> 
        <!-- global type =global menu-->
        <div [ngSwitch]="item.link_type">
            <div *ngSwitchCase="1">
                <!-- external page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)='getManu(item.intId,"externale")'>{{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a><br>
                    <div class="url-tx screen-reader">
                        <a [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'" (click)='getManu(item.intId,"externale")'>Click Here</a>
                    </div>
                </div>
                <hr>
            </div>

            <div *ngSwitchCase="2">
                <!-- plugin page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="goToPluginPage( item.plugin_page,{'plugin_id':item.intId,'selectPlugin':item.plugin_page})">{{
                        htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                    <div class="url-tx font-adjust screen-reader"><i
                        class="fa fa-hand-o-right me-2 text-green"
                        aria-hidden="true"></i> <span>{{ site_url }}{{ item.plugin_page }}</span>
                    </div>
                </div>
                <hr>
            </div>

            <div *ngSwitchCase="3">
                <!-- content page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="setSelectedData(item.intId)">{{
                        htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                    <div class="url-tx font-adjust screen-reader"><i
                        class="fa fa-hand-o-right me-2 text-green"
                        aria-hidden="true"></i> <span>{{ site_url
                        }}view/{{ item.content_page
                        }}</span></div>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="4"><!-- na -->
                <div class="content-srhsec">
                    <a href="javascript:void(0)"
                        class="srh-tx screen-reader">{{ htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                </div>
                <hr>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="2">
        <!-- global type =primary menu-->
        <div [ngSwitch]="item.link_type">
            <div *ngSwitchCase="1">
                <!-- external page -->
                <div class="content-srhsec screen-reader">
                    <a class="srh-tx" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)='getManu(item.intId,"externale")'>
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{ htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a><br>
                    <a [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)='getManu(item.intId,"externale")'>Click
                        Here</a>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="2">
                <!-- plugin page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="goToPluginPage( item.plugin_page,{'plugin_id':item.intId,'selectPlugin':item.plugin_page})">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{ htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                    <div class="url-tx font-adjust screen-reader"><i
                        class="fa fa-hand-o-right me-2 text-green"
                        aria-hidden="true"></i> <span>{{ site_url
                        }}{{ item.plugin_page }}</span>
                    </div>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="3">
                <!-- content page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="setSelectedData(item.intId)">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{ htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                        <div class="url-tx font-adjust screen-reader"><i
                            class="fa fa-hand-o-right me-2 text-green"
                            aria-hidden="true"></i> <span>{{ site_url
                            }}view/{{ item.content_page
                            }}</span></div>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="4"><!-- na -->
                <div class="content-srhsec">
                    <a href="javascript:void(0)"
                        class="srh-tx screen-reader">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{ htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}
                    </a>
                </div>
                <hr>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="3">
        <!-- global type =secondary menu-->
        <div [ngSwitch]="item.link_type">
            <div *ngSwitchCase="1">
                <!-- external page -->
                <div class="content-srhsec screen-reader">
                    <a class="srh-tx" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)='getManu(item.intId,"externale")'>
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a><br>
                    <a [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)='getManu(item.intId,"externale")'>Click
                        Here</a>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="2">
                <!-- plugin page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="goToPluginPage( item.plugin_page,{'plugin_id':item.intId,'selectPlugin':item.plugin_page})">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}
                    </a>
                    <div class="url-tx font-adjust screen-reader"><i
                        class="fa fa-hand-o-right me-2 text-green"
                        aria-hidden="true"></i> <span>{{ site_url
                        }}{{ item.plugin_page }}</span>
                    </div>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="3">
                <!-- content page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="setSelectedData(item.intId)">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                        <div class="url-tx font-adjust screen-reader"><i
                            class="fa fa-hand-o-right me-2 text-green"
                            aria-hidden="true"></i> <span>{{ site_url
                            }}view/{{ item.content_page
                            }}</span></div>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="4"><!-- na -->
                <div class="content-srhsec">
                    <a href="javascript:void(0)"
                        class="srh-tx screen-reader">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                </div>
                <hr>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="4">
        <!-- global type =tertiary menu-->
        <div [ngSwitch]="item.link_type">
            <div *ngSwitchCase="1">
                <!-- external page -->
                <div class="content-srhsec screen-reader">
                    <a class="srh-tx" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)='getManu(item.intId,"externale")'>
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.secondarymenu_name:item.secondarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a><br>
                    <a [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)='getManu(item.intId,"externale")'>Click
                        Here</a>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="2">
                <!-- plugin page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="goToPluginPage( item.plugin_page,{'plugin_id':item.intId,'selectPlugin':item.plugin_page})">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.secondarymenu_name:item.secondarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}
                    </a>
                    <div class="url-tx font-adjust screen-reader"><i
                        class="fa fa-hand-o-right me-2 text-green"
                        aria-hidden="true"></i> <span>{{ site_url
                        }}{{ item.plugin_page }}</span>
                    </div>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="3">
                <!-- content page -->
                <div class="content-srhsec">
                    <a class="srh-tx screen-reader"
                        href="javascript:void(0)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                        (click)="setSelectedData(item.intId)">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.secondarymenu_name:item.secondarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                        <div class="url-tx font-adjust screen-reader"><i
                            class="fa fa-hand-o-right me-2 text-green"
                            aria-hidden="true"></i> <span>{{ site_url
                            }}view/{{ item.content_page
                            }}</span></div>
                </div>
                <hr>
            </div>
            <div *ngSwitchCase="4"><!-- na -->
                <div class="content-srhsec">
                    <a href="javascript:void(0)"
                        class="srh-tx screen-reader">
                        {{  htmlTag(this.language=='English'?item.globalmenu_name:item.globalmenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.primarymenu_name:item.primarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.secondarymenu_name:item.secondarymenu_nameInhindi) }} ->
                        {{  htmlTag(this.language=='English'?item.TITLE:item.HINDI_TITLE) }}</a>
                </div>
                <hr>
            </div>
        </div>
    </div>
 
</div>
</div>

                                            </div>
                                        </div>



                        <div class="row mt-3" *ngIf="hascontent">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <h5 class="search-result-text mb-1 mb-3 screen-reader">{{ "SearchresultsinContent" | translate }}</h5>

                                <div *ngFor="let item of contentlist;">
                                        <div class="content-srhsec mt-3" >
                                            <a class="srh-tx screen-reader" href="javascript:void(0);"
                                                (click)="goToContentPage(item.pid)"
                                                [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'">
                                                {{ htmlTag(language=='English'?item.TITLE:item.HINDI_TITLE) }}
                                            </a>
                                            <a class="url-tx font-adjust d-flex align-items-center screen-reader" href="javascript:void(0);"
                                            (click)="goToContentPage(item.pid)" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"><i
                                                    class="fa fa-hand-o-right me-2 text-green"
                                                    aria-hidden="true"></i><span>{{ site_url
                                                }}view/{{ item.pid }}</span></a>
                                            <p class="screen-reader font-adjust" [innerHTML]="encDec.decodeHtml(contentLengthSet(language=='English'?item.DESCRIPTION:item.HINDI_DESCRIPTION,250))">
                                            </p>
                                        </div>
                                        <hr class="mb-0">
                                </div>

                                            </div>
                                        </div>


                                        <div class="screen-reader" *ngFor="let mainitem of globalsearchList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords}; let i = index;" style="display: none;">
 <p>test</p>
                                        </div>
                                        <pagination-controls class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > limit"></pagination-controls>


                                   


                                    </div>

                                                    <!-- content search section area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>